class DetailsDisclosure extends HTMLElement {
  constructor() {
    super();
    this.mainDetailsToggle = this.querySelector('details');

    this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    this.mainDetailsToggle.addEventListener('keyup', this.onKeyUp.bind(this));
  }

  onFocusOut() {
    setTimeout(() => {
      if (!this.contains(document.activeElement)) this.close();
    })
  }

  onKeyUp(event) {
    if ((event.code || '').toUpperCase() !== 'ESCAPE') return;
    if (!this.mainDetailsToggle.hasAttribute('open')) return;
    this.close();
    const summary = this.mainDetailsToggle.querySelector('summary');
    if (summary) summary.focus();
  }

  close() {
    this.mainDetailsToggle.removeAttribute('open');
    this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
  }
}

customElements.define('details-disclosure', DetailsDisclosure);
